import { useQuery } from "@tanstack/react-query";

import { fetchAgentPresenceAvailable } from "../_queries/workforcePresence.queries";
import {
  TransferAgentStatus,
  TransferAvailableAgent,
} from "../_types/workforcePresence.types";

export const AGENT_STATUS_QUERY_KEY = "agent-status";

export const useAgentStatusQuery = (companyId?: string | number | null) => {
  return useQuery({
    queryKey: [AGENT_STATUS_QUERY_KEY, companyId],
    queryFn: () => fetchAgentPresenceAvailable(Number(companyId)),
    enabled: Boolean(companyId),
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    staleTime: 20_000,
  });
};

export const findAgentStatusForContact = (
  people: TransferAvailableAgent[],
  contact: {
    uid?: string | number | null;
    email?: string | null;
  },
): TransferAvailableAgent | undefined => {
  return people.find((person) => {
    const sameUid =
      contact.uid != null &&
      person.agentUid != null &&
      String(person.agentUid) === String(contact.uid);

    const sameEmail =
      Boolean(contact.email) &&
      person.email?.toLowerCase() === contact.email?.toLowerCase();

    return sameUid || sameEmail;
  });
};

export const getAgentStatusForContact = (
  people: TransferAvailableAgent[],
  contact: {
    uid?: string | number | null;
    email?: string | null;
  },
): TransferAgentStatus => {
  const agent = findAgentStatusForContact(people, contact);
  return agent?.status ?? "disconnected";
};
